import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import Paper from '@/components/Paper'
import { useInvoiceNonInvoicable } from '@/modules/Invoice/hooks/use-invoice-non-invoicable'
import { useInvoiceListTour } from '@/modules/Invoice/hooks/use-invoice-list-tour'
import { useInvoiceListQuickHelp } from '@/modules/Invoice/hooks/use-invoice-list-quick-help'
import { useTourHandler } from '@/contexts/tour-handler'
import { useEffect } from 'react'

const NonInvoicable = () => {
    const {
        invoices,
        pagination,
        stateComponent,
        isFetching,
        params,
        columns,
        control,
        setFilter,
        filterItems,
        searchInputProps,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useInvoiceNonInvoicable()

    // Tour hooks
    const { startTour } = useInvoiceListTour('non-invoicable')
    const { registerHandler, unregisterHandler } = useTourHandler()

    // Quick help hook
    useInvoiceListQuickHelp('non-invoicable')

    // Register tour handler
    useEffect(() => {
        registerHandler(startTour)
        return () => unregisterHandler()
    }, [registerHandler, unregisterHandler, startTour])

    return (
        <Paper data-tour="invoice-list">
            <div data-tour="invoice-filter-bar">
                <FilterBar
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                    hideSearch
                />
            </div>
            {stateComponent || (
                <div data-tour="invoice-data-table">
                    <DataTableCustomized
                        columns={columns}
                        rows={invoices}
                        rowKey={(row) => row.invoice_id}
                        resizable
                        loading={isFetching && !invoices.length}
                        isFetching={isFetching}
                        emptyMessage={t('no-invoices', {
                            defaultValue: 'Không có hóa đơn nào',
                        })}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={
                            pagination
                                ? {
                                      page: params.page || 1,
                                      pageSize: params.page_size || 20,
                                      total: pagination.total || 0,
                                      onPageChange: handlePageChange,
                                      onPageSizeChange: handlePageSizeChange,
                                      pageSizeOptions: [10, 20, 50, 100],
                                  }
                                : undefined
                        }
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: t('search-invoice'),
                                tourId: 'invoice-search',
                            },
                            settings: {
                                show: true,
                                storageKey: 'invoice-non-invoicable',
                                tourId: 'invoice-settings',
                            },
                        }}
                    />
                </div>
            )}
        </Paper>
    )
}

export default NonInvoicable
